import { buildFunctions, convertSelectOptionToSelectSearchOption, createOption, overloadOptions } from './FunctionBuilder.Helpers';
import BaseOperandProps from '../Props/BaseOperandProps';
import CustomDataSourceLegitimacy from '../../../../infrastructure/types/Functions/CustomDataSourceLegitimacy';
import FirdsResultSetBuilder from '../FirdsResultSet/FirdsResultSetBuilder';
import FunctionDescription from './FunctionDescription/FunctionDescription';
import functionHelper from '../../../../infrastructure/helpers/functions/function/functionHelper';
import functionName from '../../../../infrastructure/constants/functions/definition/functionName';
import functionOptions from '../../../../infrastructure/constants/functions/definition/functionOptions';
import LeiResultSetBuilder from '../LeiResultSet/LeiResultSetBuilder';
import NumberRange from '../../../Common/NumberRange/NumberRange';
import Operand from '../../../../types/functions/Operand/Operand';
import OverloadCheckbox from './OverloadCheckbox';
import OverloadRadio from './OverloadRadio';
import pseudoFunction from '../../../../infrastructure/constants/functions/pseudoFunction';
import pseudoFunctionHelper from '../../../../infrastructure/helpers/functions/function/pseudoFunctionHelper';
import React from 'react';
import SelectOption from '../../../../infrastructure/types/SelectOption';
import stringHelper from '../../../../infrastructure/helpers/common/stringHelper';
import typeHelper from '../../../../infrastructure/helpers/common/typeHelper';
import IsinsSetBuilder from '../FirdsResultSet/IsinsSetBuilder';
import LeiSetBuilder from '../LeiResultSet/LeiSetBuilder';
import operandType from '../../../../infrastructure/constants/functions/operandType';
import SelectSearch, { SelectSearchOption, SelectSearchProps, SelectedOption, SelectedOptionValue } from 'react-select-search';
import ExchangeRatesResultSetBuilder from '../ExchangeRatesResultSet/ExchangeRatesResultSetBuilder';
import ExchangeRatesSetBuilder from '../ExchangeRatesResultSet/ExchangeRatesSetBuilder';
import Selector from '../../../../types/report/Selector';
import locationType from '../../../../types/functions/Location/LocationType';
import userDefinedFunctionHelper from '../../../Report/UserDefinedFunctions/UserDefinedFunctionHelper';
import repeat from '../../../../infrastructure/helpers/common/array/repeat';
import UserDefinedFunction from '../../../../types/report/UserDefinedFunction';
import operandHelper from '../../../../infrastructure/helpers/functions/operand/operandHelper';
import ReportLogicLocation from '../../../../types/functions/Location/ReportLogicLocation';
import { getFunctionDefinition } from '../../../../infrastructure/helpers/functions/function/functionHelper.Helpers';
import FunctionArgumentsModal from '../../Arguments/FunctionArgumentsModal';
import functionDefinitions from '../../../../infrastructure/constants/functions/definition/functionDefinitions';
import FunctionDefinition from '../../../../types/functions/FunctionDefinition';
import Mode from '../../../../types/report/Mode';
import ComponentType from '../../../../types/report/ComponentType';

type Props =
    BaseOperandProps &
    {
        customDataSourceLegitimacy: CustomDataSourceLegitimacy;
        pseudoFunction: string | null;
        isinSelectors: Selector[];
        leiSelectors: Selector[];
        exchangeRatesSelectors: Selector[];
        userDefinedFunctions: UserDefinedFunction[];
        globalUserDefinedFunctions: UserDefinedFunction[];
        location: ReportLogicLocation;
        reportConfigType: string;
    };

class FunctionBuilder extends React.Component<Props, { showUploadArgumentsFromCsvModal: boolean, options: SelectSearchOption[] }> {
    private maxArrayArgumentCount: number;
    private firdsPseudoFunctionInitialized: boolean;
    private firdsPseudoFunction: Operand;
    private leiPseudoFunction: Operand;
    private exchangeRatesPseudoFunction: Operand;
    constructor(props: Props) {
        super(props);

        this.state = {
            showUploadArgumentsFromCsvModal: false,
            options: []
        }

        this.maxArrayArgumentCount = 50;

        this.onFunctionChange = this.onFunctionChange.bind(this);
        this.onFirdsDataSourceChange = this.onFirdsDataSourceChange.bind(this);
        this.onIsinSelectorChange = this.onIsinSelectorChange.bind(this);
        this.onLeiSelectorChange = this.onLeiSelectorChange.bind(this);
        this.onExchangeRatesSelectorChange = this.onExchangeRatesSelectorChange.bind(this);
        this.onArgumentCountChange = this.onArgumentCountChange.bind(this);

        this.mapToSelectListFunction = this.mapToSelectListFunction.bind(this);

        this.isArrayFunction = this.isArrayFunction.bind(this);
        this.getMinArrayArgumentCount = this.getMinArrayArgumentCount.bind(this);
        this.countArrayArguments = this.countArrayArguments.bind(this);
        this.mapOption = this.mapOption.bind(this);

        this.firdsPseudoFunctionInitialized = false

        this.firdsPseudoFunction = pseudoFunctionHelper.buildSpecial(operandType.firdsResultSetEsma, this.props?.isinSelectors?.length === 0 ? 0 : this.props?.isinSelectors?.[0]?.number || 0, ComponentType.IsinSelector);
        this.leiPseudoFunction = pseudoFunctionHelper.buildSpecial(operandType.leiResultSetLevel1, this.props?.leiSelectors?.length === 0 ? 0 : this.props?.leiSelectors?.[0]?.number || 0, ComponentType.LeiSelector);
        this.exchangeRatesPseudoFunction = pseudoFunctionHelper.buildSpecial(operandType.exchangeRatesResultSet, this.props.exchangeRatesSelectors?.length === 0 ? 0 : this.props?.exchangeRatesSelectors?.[0]?.number || 0, ComponentType.ExchangeRatesSelector);

        this.onFunctionitemChange = this.onFunctionitemChange.bind(this);

        this.qualifies = this.qualifies.bind(this);
        this.onUploadFromCsvButtonClick = this.onUploadFromCsvButtonClick.bind(this);
        this.onCsvArgumentsSaveClick = this.onCsvArgumentsSaveClick.bind(this);
        this.getFunctions = this.getFunctions.bind(this);
    }

    componentDidMount() {

        let userDefinedFunctionsOptions = this.props.userDefinedFunctions.filter(this.qualifies).map(x => createOption(x, ComponentType.UserDefinedFunction));

        let globalUserDefinedFunctionsOptions = this.props.globalUserDefinedFunctions.filter(this.qualifies).map(x => createOption(x, ComponentType.GlobalUserDefinedFunction));

        this.setState({
            options: buildFunctions(functionOptions.concat(userDefinedFunctionsOptions)
                .concat(globalUserDefinedFunctionsOptions)
                .map(this.mapOption).map(convertSelectOptionToSelectSearchOption))
        });
    }

    onFunctionChange(value: string, mode?: string, innerType?: string): void {

        let changes: Operand;

        if (pseudoFunctionHelper.isPseudoFunction(value)) {

            let dataSourceType = pseudoFunctionHelper.resolveDefaultDataSourceType(value);

            changes = pseudoFunctionHelper.build(dataSourceType);

            if (value === pseudoFunction.firds) {
                this.props.onOperandChange(this.firdsPseudoFunction, { doNotPopulate: false, pseudoFunction: pseudoFunction.firds });
                return;
            }
            else if (value === pseudoFunction.lei) {
                this.props.onOperandChange(this.leiPseudoFunction, { doNotPopulate: false, pseudoFunction: pseudoFunction.lei });
                return;
            }
            else if (value === pseudoFunction.exchangeRates) {
                this.props.onOperandChange(this.exchangeRatesPseudoFunction, { doNotPopulate: false, pseudoFunction: pseudoFunction.exchangeRates });
                return;
            }
        }
        else if (typeHelper.isStringNumber(value)) {

            let functions = innerType === ComponentType.UserDefinedFunction ? this.props.userDefinedFunctions : this.props.globalUserDefinedFunctions;

            let func = userDefinedFunctionHelper.getByNumber(functions, parseInt(value));

            changes = {
                operandType: innerType === ComponentType.UserDefinedFunction ? operandType.userDefinedFunction : operandType.globalUserDefinedFunction,
                functionNumber: func.number,
                function: '',
                subType: innerType,
            } as Operand;

            changes.arguments = repeat(func.parameters.length, operandHelper.getEmpty);
        }
        else {
            changes = {
                operandType: operandType.function,
                function: value,
                functionNumber: null
            } as Operand;

            if (value) {
                changes.arguments = functionHelper.getEmptyArguments(value, null);
            }
        }

        this.props.onOperandChange(changes, { doNotPopulate: false, pseudoFunction: pseudoFunctionHelper.isPseudoFunction(value) ? value : null });
    }

    onFirdsDataSourceChange(value: string): void {

        if (!this.firdsPseudoFunctionInitialized) {
            this.firdsPseudoFunction = pseudoFunctionHelper.buildSpecial(value, 1, ComponentType.IsinSelector);
            this.firdsPseudoFunctionInitialized = true;
        }

        (this.firdsPseudoFunction.arguments as Operand[])[0].operandType = value;

        this.props.onOperandChange(this.firdsPseudoFunction, { doNotPopulate: false, pseudoFunction: pseudoFunction.firds });
    }

    onIsinSelectorChange(value: string): void {

        if (!this.firdsPseudoFunctionInitialized) {
            this.firdsPseudoFunction = pseudoFunctionHelper.buildSpecial(operandType.firdsResultSetEsma, parseInt(value), ComponentType.IsinSelector);
            this.firdsPseudoFunctionInitialized = true;
        }

        (this.firdsPseudoFunction.arguments as Operand[])[0].selectorNumber = parseInt(value);

        this.props.onOperandChange(this.firdsPseudoFunction, { doNotPopulate: false, pseudoFunction: pseudoFunction.firds });
    }

    onLeiSelectorChange(value: string): void {

        let changes = pseudoFunctionHelper.buildSpecial(operandType.leiResultSetLevel1, parseInt(value), ComponentType.LeiSelector);

        this.props.onOperandChange(changes, { doNotPopulate: false, pseudoFunction: pseudoFunction.lei });
    }

    onExchangeRatesSelectorChange(value: string): void {

        let changes = pseudoFunctionHelper.buildSpecial(operandType.exchangeRatesResultSet, parseInt(value), ComponentType.ExchangeRatesSelector);

        this.props.onOperandChange(changes, { doNotPopulate: false, pseudoFunction: pseudoFunction.exchangeRates });
    }

    onArgumentCountChange(value: number): void {

        let changes = {} as Operand;

        changes.arguments = functionHelper.getEmptyArguments(this.props.operand.function, value);

        this.props.onOperandChange(changes);
    }

    mapToSelectListFunction(func: string, number: number | null, typeOfOperand: string): string {

        if (typeHelper.isString(this.props.pseudoFunction)) {

            return this.props.pseudoFunction as string;
        }

        if (!func && this.props.operand.operandType === operandType.globalUserDefinedFunction) {

            let funcName = this.props.userDefinedFunctions.find(x => x.number === this.props.operand.functionNumber && x.mode === Mode.Global)?.name || '';

            if (this.state.options.length === 0) {
                return funcName;
            }
            else {
                return this.state.options.find(x => x.type as string === Mode.Global && parseInt((x.items as any)[0].value) === number)?.name || '';
            }
        }
        if (!func && this.props.operand.operandType === operandType.userDefinedFunction) {
            let funcName = this.state.options.find(x => x.type as string === Mode.Local && parseInt((x.items as any)[0].value) === number)?.name || '';

            return funcName;
        }

        if (!func || stringHelper.isEmpty(func)) {

            let mode = Mode.Local;

            if (typeOfOperand === operandType.globalUserDefinedFunction) {
                mode = Mode.Global;
            }

            return this.state.options.find(x => x.type as string === mode && parseInt((x.items as any)[0].value) === number)?.name || '';
        }

        let try1 = functionOptions.find(x => x.value === func);

        if (typeHelper.isObject(try1)) {

            return (try1 as SelectOption).text;
        }

        let try2 = functionOptions.find(x => func.startsWith(x.value));

        if (typeHelper.isObject(try2)) {

            return (try2 as SelectOption).text;
        }

        let try3 = functionOptions.find(x => x.value.startsWith(func));

        return (try3 as SelectOption).text;
    }

    isArrayFunction(): boolean {

        let isFunction = stringHelper.isNonEmpty(this.props.operand.function);
        if (!isFunction) {
            return false;
        }

        return functionHelper.isArrayFunction(this.props.operand.function);
    }

    getMinArrayArgumentCount(): number {

        let isFunction = stringHelper.isNonEmpty(this.props.operand.function);
        if (!isFunction) {
            return 0;
        }

        return functionHelper.getMinArrayArgumentCount(this.props.operand.function);
    }

    countArrayArguments(): number {

        let isFunction = stringHelper.isNonEmpty(this.props.operand.function);
        if (!isFunction) {
            return 0;
        }

        if (!functionHelper.isArrayFunction(this.props.operand.function)) {
            return 0;
        }

        return (this.props.operand.arguments as Operand[]).length - functionHelper.getNonArrayArgumentCount(this.props.operand.function);
    }

    mapOption(option: SelectOption): SelectOption {

        switch (option.value) {
            case pseudoFunction.firds:
            case functionName.activeOnTradingDate:
                return { value: option.value, text: option.text, disabled: !this.props.customDataSourceLegitimacy.isin };

            case pseudoFunction.lei:
                return { value: option.value, text: option.text, disabled: !this.props.customDataSourceLegitimacy.lei };

            case pseudoFunction.exchangeRates:
                return { value: option.value, text: option.text, disabled: !this.props.customDataSourceLegitimacy.exchangeRates };

            case pseudoFunction.annaDsbUpiEnrichment:
                return { value: option.value, text: option.text, disabled: !this.props.customDataSourceLegitimacy.annaDsbUpiEnrichment };

            default:
                return option;
        }
    }

    onFunctionitemChange(selectedValue: SelectedOptionValue | SelectedOptionValue[], selectedOptionObject: SelectedOption | SelectedOption[]): void {

        let option = selectedOptionObject as any;

        let selectedOption = this.state.options[option.index];

        let items = selectedOption.items as SelectSearchOption[];

        this.onFunctionChange(items[0]?.value, option.type, option.innerType);
    }

    qualifies(func: UserDefinedFunction): boolean {

        if (this.props.location.statement === locationType.statement.userDefinedFunction && func.mode === Mode.Local) {

            return this.props.location.statementNumber > func.number;
        }

        return true;
    }

    onUploadFromCsvButtonClick() {
        this.setState({ showUploadArgumentsFromCsvModal: true });
    }

    onCsvArgumentsSaveClick(values: string[]) {

        let definition = functionDefinitions.find(x => x.name === this.props.operand.function) as FunctionDefinition;

        let changes = {} as Operand;

        changes.arguments = this.prepareArguments(definition, values);

        this.setState({ showUploadArgumentsFromCsvModal: false });

        this.props.onOperandChange(changes);
    }

    prepareArguments(functionDefinition: FunctionDefinition, values: string[]): Operand[] {

        let args: Operand[] = functionDefinition?.isMethod ? [{} as Operand] : [];

        values.forEach((val) => {

            let dt = functionHelper.getArgumentDataType(val);

            let operand = operandHelper.getEmpty();

            operand.operandType = operandType.constant;
            operand.dataType = dt;
            operand.value = val;

            args.push(operand);
        });

        return args;
    }

    getFunctions() {
        if (this.props.operand.operandType === operandType.globalUserDefinedFunction) {
            return this.props.userDefinedFunctions.filter(x => x.mode === Mode.Global);
        }
        else {
            return this.props.userDefinedFunctions.filter(x => x.mode !== Mode.Global);
        }
    }

    render(): JSX.Element {

        let allowUploadFromCsv = this.props.operand.function ? getFunctionDefinition(this.props.operand.function).allowUploadFromCsv : false;

        let definition = this.props.operand.function ?
            getFunctionDefinition(this.props.operand.function) : undefined;

        return (
            <>
                {definition?.private ?
                    <SelectSearch
                        options={[{ name: this.props.operand.function, value: this.props.operand.function } as SelectSearchOption]}
                        onChange={() => { }}
                        value={this.props.operand.function}
                        search={false}
                    />
                    :
                    <SelectSearch
                        options={this.state.options}
                        onChange={this.onFunctionitemChange}
                        value={this.mapToSelectListFunction(this.props.operand.function, this.props.operand.functionNumber, this.props.operand.operandType)}
                        search={true}
                    />
                }
                <OverloadRadio
                    options={overloadOptions.toArray}
                    function={this.props.operand.function}
                    name="to-array-overloads"
                    onChange={this.onFunctionChange} />

                <OverloadRadio
                    options={overloadOptions.toDateTime}
                    function={this.props.operand.function}
                    name="to-dateTime-overloads"
                    onChange={this.onFunctionChange} />

                <OverloadRadio
                    options={overloadOptions.toDate}
                    function={this.props.operand.function}
                    name="to-date-overloads"
                    onChange={this.onFunctionChange} />

                <OverloadRadio
                    options={overloadOptions.toString}
                    function={this.props.operand.function}
                    name="to-string-overloads"
                    onChange={this.onFunctionChange} />

                <OverloadRadio
                    options={overloadOptions.in}
                    function={this.props.operand.function}
                    name="in-overloads"
                    onChange={this.onFunctionChange} />

                <OverloadRadio
                    options={overloadOptions.round}
                    function={this.props.operand.function}
                    name="round-overloads"
                    onChange={this.onFunctionChange} />

                <OverloadCheckbox
                    function={this.props.operand.function}
                    true={functionName.substringLength}
                    false={functionName.substring}
                    label="Include length"
                    onChange={this.onFunctionChange} />

                <OverloadCheckbox
                    function={this.props.operand.function}
                    true={functionName.replaceIgnoreCase}
                    false={functionName.replace}
                    label="Include ignoreCase"
                    onChange={this.onFunctionChange} />

                <OverloadCheckbox
                    function={this.props.operand.function}
                    true={functionName.countHasValue}
                    false={functionName.count}
                    label="Particular field"
                    onChange={this.onFunctionChange} />

                <OverloadCheckbox
                    function={this.props.operand.function}
                    true={functionName.concatenateDelimiter}
                    false={functionName.concatenate}
                    label="Add delimiter"
                    onChange={this.onFunctionChange} />

                <OverloadRadio
                    options={overloadOptions.addDays}
                    function={this.props.operand.function}
                    name="add-days-overloads"
                    onChange={this.onFunctionChange} />

                <OverloadRadio
                    options={overloadOptions.all}
                    function={this.props.operand.function}
                    name="all-overloads"
                    onChange={this.onFunctionChange} />

                <OverloadRadio
                    options={overloadOptions.any}
                    function={this.props.operand.function}
                    name="any-overloads"
                    onChange={this.onFunctionChange} />

                <OverloadRadio
                    options={overloadOptions.first}
                    function={this.props.operand.function}
                    name="first-overloads"
                    onChange={this.onFunctionChange} />

                <OverloadRadio
                    options={overloadOptions.last}
                    function={this.props.operand.function}
                    name="last-overloads"
                    onChange={this.onFunctionChange} />

                {
                    this.props.pseudoFunction === pseudoFunction.firds &&
                    <FirdsResultSetBuilder
                        value={(this.props.operand.arguments as Operand[])[0].operandType}
                        onChange={this.onFirdsDataSourceChange} />
                }
                {
                    this.props.pseudoFunction === pseudoFunction.firds &&
                    <IsinsSetBuilder
                        options={this.props.isinSelectors}
                        value={(this.props.operand.arguments as Operand[])[0].selectorNumber}
                        onChange={this.onIsinSelectorChange} />
                }
                {
                    this.props.pseudoFunction === pseudoFunction.lei &&
                    <LeiResultSetBuilder value={(this.props.operand.arguments as Operand[])[0].operandType} />
                }
                {
                    this.props.pseudoFunction === pseudoFunction.lei &&
                    <LeiSetBuilder
                        options={this.props.leiSelectors}
                        value={(this.props.operand.arguments as Operand[])[0].selectorNumber}
                        onChange={this.onLeiSelectorChange} />
                }
                {
                    this.props.pseudoFunction === pseudoFunction.exchangeRates &&
                    <ExchangeRatesResultSetBuilder value={(this.props.operand.arguments as Operand[])[0].operandType} />
                }
                {
                    this.props.pseudoFunction === pseudoFunction.exchangeRates &&
                    <ExchangeRatesSetBuilder
                        options={this.props.exchangeRatesSelectors}
                        value={(this.props.operand.arguments as Operand[])[0].selectorNumber}
                        onChange={this.onExchangeRatesSelectorChange} />
                }
                {
                    (stringHelper.isNonEmpty(this.props.operand.function) ||
                        typeHelper.isNumber(this.props.operand.functionNumber)) &&
                    !typeHelper.isString(this.props.pseudoFunction) &&
                    <div className="mt-2">
                        <FunctionDescription
                            operand={this.props.operand}
                            userDefinedFunctions={this.props.userDefinedFunctions}
                            globalUserDefinedFunctions={this.props.globalUserDefinedFunctions} >
                            {
                                this.isArrayFunction() &&
                                <tr>
                                    <td>Arguments:</td>
                                    <td>
                                        <NumberRange
                                            min={this.getMinArrayArgumentCount()}
                                            max={this.maxArrayArgumentCount}
                                            value={this.countArrayArguments()}
                                            onChange={this.onArgumentCountChange}
                                            displayState={value => `(${value}) `} />
                                    </td>
                                    {allowUploadFromCsv &&
                                        <td>
                                            <button onClick={this.onUploadFromCsvButtonClick} className="btn btn-light white-space-nowrap">Upload from csv</button>
                                        </td>
                                    }
                                </tr>
                            }
                        </FunctionDescription>
                    </div>
                }
                {
                    this.state.showUploadArgumentsFromCsvModal &&

                    <FunctionArgumentsModal
                        functionDefinition={getFunctionDefinition(this.props.operand.function)}
                        onSaveClick={this.onCsvArgumentsSaveClick}
                        maxArrayArgumentCount={this.maxArrayArgumentCount}
                    />
                }
            </>
        );
    }
}

export default FunctionBuilder;
